import React from "react";
import { Sparkles, TrendingUp, Circle } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function OurCulturalPillars() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const pillars = [{
    title: "Sonic Landscapes",
    icon: Sparkles,
    description: "Deep bass tech-house frequencies at 126 BPM, creating a driving momentum that syncs your breath with the heartbeat of the room."
  }, {
    title: "Culinary Art",
    icon: TrendingUp,
    description: "A high-vibration dining ritual featuring candlelit textures and exotic flavors designed to nourish the body and ignite the soul."
  }, {
    title: "Collective Ritual",
    icon: Circle,
    description: "The peak-time momentum of shared movement, where ancient practice meets modern energy in a godly-feeling sanctuary."
  }];
  return <section data-section-id="63625" id="the-pillars-of-presence" className="dark bg-background py-24 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
        <div className="absolute top-[-10%] right-[-5%] w-[500px] h-[500px] bg-primary/10 rounded-lg blur-3xl opacity-40" />
        <div className="absolute bottom-[-10%] left-[-5%] w-[500px] h-[500px] bg-secondary/5 rounded-lg blur-3xl opacity-30" />
      </div>

      <div ref={ref} className={cn("container mx-auto px-4 relative z-10 transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-7xl font-default font-bold text-foreground mb-6 tracking-tight">
            The Pillars of Presence
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto font-sans text-xl tracking-wider leading-relaxed">
            An immersive journey where movement, music, and ritual converge to awaken the senses and celebrate the collective spirit.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {pillars.map((pillar, i) => <div key={i} data-index={i} className="group h-full">
              <Card className="h-full bg-card/40 backdrop-blur-xl border-border/40 transition-all duration-700 ease-out hover:-translate-y-[10px] hover:shadow-[0_20px_40px_-15px_var(--color-primary)] hover:border-[#a855f7]/60">
                <CardHeader className="pb-4">
                  <div className="mb-6 inline-flex items-center justify-center w-16 h-16 rounded-lg bg-primary/10 text-primary group-hover:bg-primary group-hover:text-primary-foreground transition-all duration-500">
                    <pillar.icon className="w-8 h-8" strokeWidth={1} />
                  </div>
                  <CardTitle className="text-2xl font-default font-semibold text-foreground group-hover:text-primary transition-colors tracking-wide">
                    {pillar.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-muted-foreground font-sans leading-relaxed tracking-normal">
                    {pillar.description}
                  </p>
                </CardContent>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}